import { z } from 'zod'

export const Vacation = z.object({
  is_enabled: z.boolean(),
  subject: z.string().optional(),
  message: z.string().optional(),
  from_date: z.string().optional(),
  to_date: z.string().optional()
})

export type Vacation = z.infer<typeof Vacation>

export const UpdateVacationRequest = z.object({
  is_enabled: z.boolean(),
  subject: z.string().optional(),
  message: z.string().optional(),
  from_date: z.string().optional(),
  to_date: z.string().optional()
})

export type UpdateVacationRequest = z.infer<typeof UpdateVacationRequest>
